(() => {
  'use strict';
  const identifier=value=>typeof value==='string'&&value.trim().length>0&&value.length<=128;
  const positive=value=>Number.isSafeInteger(value)&&value>0;
  const object=value=>!!value&&typeof value==='object'&&!Array.isArray(value);
  const supported=new Map([[10213890294065,'pastel-cloud-hoodie-quantity-v1'],[8901234557233,'cloud-sweatshirt-quantity-v1'],
    [10342962069809,'cloud-tshirt-quantity-v1'],[10343032389937,'cloud-short-quantity-v1'],[10270928339249,'cloud-calm-campaign-v1']]);
  const foreignMarkers=['__kaching_bundles','_landing_offer_campaign','_grounding_landing_campaign','_calm_kit_campaign','_offer_id','_offer_payload'];
  function configuration(value){
    const counts=value?.offerId==='cloud-tshirt-quantity-v1'?[1,2,3]:[1,2,4];
    const rounded=['cloud-tshirt-quantity-v1','cloud-short-quantity-v1'].includes(value?.offerId);
    const campaign=value?.offerId==='cloud-calm-campaign-v1';
    if(!object(value)||value.version!==1||typeof value.enabled!=='boolean'||supported.get(value.productId)!==value.offerId||
      !Array.isArray(value.eligibleVariantIds)||!value.eligibleVariantIds.length||!value.eligibleVariantIds.every(positive)||
      new Set(value.eligibleVariantIds).size!==value.eligibleVariantIds.length||!object(value.gifts)||(!rounded&&!Object.keys(value.gifts).length)||
      !Object.entries(value.gifts).every(([key,id])=>identifier(key)&&positive(id))||new Set(Object.values(value.gifts)).size!==Object.keys(value.gifts).length||
      Object.values(value.gifts).some(id=>value.eligibleVariantIds.includes(id))||!Array.isArray(value.tiers)||value.tiers.length!==3||
      !value.tiers.every((tier,i)=>object(tier)&&tier.minimumQuantity===counts[i]&&Number.isSafeInteger(tier.percentage)&&tier.percentage>=0&&tier.percentage<=100&&
        Array.isArray(tier.gifts)&&new Set(tier.gifts).size===tier.gifts.length&&tier.gifts.every(key=>Object.hasOwn(value.gifts,key))))return null;
    if(rounded&&(Object.keys(value.gifts).length||value.pricing||value.rounding?.precision!==100||value.rounding.direction!=='up'||
      value.rounding.perItem!==true||value.rounding.discountedOnly!==true||!value.tiers.every((tier,i)=>tier.percentage===[0,13,28][i])))return null;
    if(campaign&&(value.rounding||value.pricing?.kind!=='buy-x-get-y'||value.pricing.buyQuantity!==3||value.pricing.getQuantity!==1||
      value.gifts['cloud-fidget']!==47826677072177||Object.keys(value.gifts).length!==1||
      !value.tiers.every((tier,i)=>tier.percentage===[0,12,25][i]&&(i<2?tier.gifts.length===0:tier.gifts.length===1&&tier.gifts[0]==='cloud-fidget'))))return null;
    if(!rounded&&!campaign&&(value.pricing||value.rounding))return null;
    return value;
  }
  const signature=value=>JSON.stringify([value.version,value.enabled,value.offerId,value.productId,[...value.eligibleVariantIds].sort((a,b)=>a-b),
    Object.entries(value.gifts).sort(([a],[b])=>a.localeCompare(b)),value.tiers.map(t=>[t.minimumQuantity,t.percentage,[...t.gifts].sort()]),value.rounding||null,value.pricing||null]);
  const offers=new Map();
  try{
    const registry=JSON.parse(document.querySelector('[data-quantity-offers]')?.textContent||'null');
    if(registry?.version===1&&Array.isArray(registry.offers)&&registry.offers.every(configuration)&&
      new Set(registry.offers.map(o=>o.offerId)).size===registry.offers.length&&new Set(registry.offers.map(o=>o.productId)).size===registry.offers.length)
      registry.offers.forEach(offer=>offers.set(offer.offerId,offer));
  }catch{}
  function matches(value){
    const offer=configuration(value),registered=offers.get(offer?.offerId);
    return !!registered?.enabled&&!!offer?.enabled&&signature(registered)===signature(offer);
  }
  const tierFor=(offer,quantity)=>positive(quantity)?offer.tiers.findLast(tier=>quantity>=tier.minimumQuantity):undefined;
  function items(offer,variants,giftCatalog,instance){
    if(!matches(offer))throw new Error('pending');
    if(!identifier(instance)||!Array.isArray(variants)||!offer.tiers.some(tier=>tier.minimumQuantity===variants.length))throw new Error('configuration');
    const tier=tierFor(offer,variants.length),paid=new Map();
    for(const variant of variants){
      if(!positive(variant?.id)||!offer.eligibleVariantIds.includes(variant.id)||variant.available!==true)throw new Error('unavailable');
      const item=paid.get(variant.id)||{id:variant.id,quantity:0,properties:{_cn_offer_id:offer.offerId,_cn_offer_instance:instance,_cn_offer_role:'qualifying'}};
      item.quantity++;paid.set(item.id,item);
    }
    const gifts=tier.gifts.map(key=>{
      const id=offer.gifts[key];
      if(!giftCatalog.some(gift=>gift.id===id&&gift.available===true))throw new Error('gift_unavailable');
      return {id,quantity:1,properties:{_cn_offer_id:offer.offerId,_cn_offer_instance:instance,_cn_offer_role:'gift',_cn_offer_gift:key}};
    });
    return [...paid.values(),...gifts];
  }
  function giftUpdates(cart){
    const updates={};
    for(const offer of offers.values()){
      if(!offer.enabled)continue;
      const groups=new Map();
      for(const item of cart.items||[]){
        const props=item.properties||{};
        if(props._cn_offer_id!==offer.offerId||!identifier(props._cn_offer_instance))continue;
        const group=groups.get(props._cn_offer_instance)||{quantity:0,gifts:[],invalid:false,foreign:false};groups.set(props._cn_offer_instance,group);
        if(foreignMarkers.some(key=>props[key]!=null)){group.foreign=true;continue;}
        if(props._cn_offer_role==='qualifying'){
          if(Number(item.product_id)!==offer.productId||!offer.eligibleVariantIds.includes(Number(item.variant_id))||!positive(item.quantity)||props._cn_offer_gift!=null)group.invalid=true;
          else group.quantity+=item.quantity;
        }else if(props._cn_offer_role==='gift'){
          if(offer.gifts[props._cn_offer_gift]===Number(item.variant_id)&&identifier(item.key))group.gifts.push(item);
          else group.invalid=true;
        }else group.invalid=true;
      }
      for(const group of groups.values()){
        if(group.foreign)continue;
        const tier=group.invalid?undefined:tierFor(offer,group.quantity),seen=new Set();
        for(const item of group.gifts){
          const key=item.properties._cn_offer_gift,earned=!!tier?.gifts.includes(key)&&positive(item.quantity)&&!seen.has(key);
          if(earned)seen.add(key);
          const quantity=earned?1:0;if(item.quantity!==quantity)updates[item.key]=quantity;
        }
      }
    }
    return updates;
  }
  function quote(offer,variants){
    if(!configuration(offer)||!Array.isArray(variants)||!offer.tiers.some(tier=>tier.minimumQuantity===variants.length)||
      !variants.every(variant=>offer.eligibleVariantIds.includes(variant.id)&&Number.isSafeInteger(variant.price)&&variant.price>=0))throw new Error('configuration');
    const tier=tierFor(offer,variants.length),original=variants.reduce((sum,variant)=>sum+Math.max(variant.price,variant.compare_at_price||0),0);
    const subtotal=variants.reduce((sum,variant)=>sum+variant.price,0);
    let total=variants.reduce((sum,variant)=>sum+variant.price-Math.floor(variant.price*tier.percentage/100),0);
    if(offer.pricing&&variants.length===4)total=subtotal-Math.min(...variants.map(variant=>variant.price));
    else if(offer.rounding&&tier.percentage>0)total=Math.min(subtotal,Math.ceil(total/variants.length/100)*100*variants.length);
    return {original,total};
  }
  window.CloudNineQuantityOffers={configuration,matches,items,giftUpdates,quote};
})();
